import React, {Component} from 'react';
import {Formik} from "formik";
import * as Yup from 'yup';

import {TextInput} from "../Boilerplate/formikComponents";
import {Form, Button} from "antd";
import LinkButton from "../Boilerplate/LinkButton";

class EditProfileForm extends Component {
  constructor(props) {
    super(props);

  }

  render() {
    const { onSubmit, current } = this.props;
    return (
      <Formik
        initialValues={current || {}}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit && onSubmit(values);
        }}
        validationSchema={Yup.object().shape({
          firstname: Yup.string().required('You must enter your first name.'),
          lastname: Yup.string().required('You must enter your last name.')
        })}
      >
        {props => {
          const {
            // eslint-disable-next-line
            values, touched, errors, isSubmitting, handleChange, handleBlur, dirty,
            handleSubmit,
          } = props;
          return (
            <Form id='user-registration' onSubmit={handleSubmit}>
              <TextInput
                {...props}
                placeholder='First Name'
                name='firstname'
              />
              <TextInput
                {...props}
                placeholder='Last Name'
                name='lastname'
              />
              <TextInput
                {...props}
                placeholder='Middle Name'
                name='middlename'
              />
              <TextInput
                {...props}
                placeholder='Title'
                name='title'
              />
              <TextInput
                {...props}
                placeholder='Phone'
                name='phone'
              />
              <TextInput
                {...props}
                placeholder='Cell'
                name='cell'
              />
              <TextInput
                {...props}
                placeholder='Fax'
                name='fax'
              />
              <Form.Item>
                <Button.Group>
                <Button type='primary' onClick={handleSubmit}>Submit</Button>
                <LinkButton to='/settings/profile'>Cancel</LinkButton>
                </Button.Group>
              </Form.Item>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

EditProfileForm.propTypes = {};

export default EditProfileForm;



// WEBPACK FOOTER //
// ./src/components/Settings/EditProfileForm.js